import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './SpinLoader.css';

class SpinLoader extends Component {
  render() {
    const { style } = this.props;

    return (
      <div className="sk-fading-circle" style={style}>
        <div className="sk-circle1 sk-circle" />
        <div className="sk-circle2 sk-circle" />
        <div className="sk-circle3 sk-circle" />
        <div className="sk-circle4 sk-circle" />
        <div className="sk-circle5 sk-circle" />
        <div className="sk-circle6 sk-circle" />
        <div className="sk-circle7 sk-circle" />
        <div className="sk-circle8 sk-circle" />
        <div className="sk-circle9 sk-circle" />
        <div className="sk-circle10 sk-circle" />
        <div className="sk-circle11 sk-circle" />
        <div className="sk-circle12 sk-circle" />
      </div>
    );
  }
}

SpinLoader.propTypes = {
  style: PropTypes.object,
};
SpinLoader.defaultProps = {
  style: {}
};

export default SpinLoader;



// WEBPACK FOOTER //
// ./src/cms/form/SpinLoader.js